import { useTranslation } from "react-i18next";
import { FaRedo } from "react-icons/fa";
import Loader from "../../components/Loader";
import UbiquitiInternetChart from "./UbiquitiInternetChart";

const getLeftMetricLabel = (activeChartMode, activeView, wifiLeftAxisLabel) => {
  if (activeChartMode === "airtime") {
    return "%";
  }

  if (activeChartMode === "flows") {
    return "Flows";
  }

  return activeView === "wifi" ? wifiLeftAxisLabel : "ms";
};

const getRightMetricLabel = (activeChartMode) => (
  activeChartMode === "airtime" || activeChartMode === "flows" ? "" : "Mbps"
);

export default function UbiquitiGraphPanel({
  activeChartMode,
  activeView,
  chartRows,
  healthScore,
  isChartFetching,
  isChartLoading,
  isChartUpdating,
  isRefreshing,
  onRefresh,
  theme,
  visibleSeries,
  wifiConnectivityScore,
  wifiLeftAxisLabel,
}) {
  const { t } = useTranslation();
  const availabilityScore = activeView === "wifi" ? wifiConnectivityScore ?? 0 : healthScore;

  return (
    <article className={`ubiquiti-chart-panel ${isChartUpdating ? "is-updating" : ""}`} aria-busy={isChartFetching}>
      <div className="ubiquiti-chart-metrics">
        <span>{getLeftMetricLabel(activeChartMode, activeView, wifiLeftAxisLabel)}</span>
        <span>{getRightMetricLabel(activeChartMode)}</span>
      </div>
      {isChartLoading ? (
        <div className="ubiquiti-chart-loading">
          <Loader />
        </div>
      ) : (
        <UbiquitiInternetChart
          rows={chartRows}
          theme={theme}
          mode={activeChartMode}
          visibleSeries={visibleSeries}
        />
      )}
      {isChartUpdating ? <span className="ubiquiti-chart-refreshing" aria-hidden="true"></span> : null}
    </article>
  );
}
